










import { defineComponent } from "@vue/composition-api";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import BaseCheckbox from "@/components/BaseCheckbox/BaseCheckbox.vue";

export default defineComponent({
  name: "TagItem",
  components: { BaseCheckbox },
  props: {
    tagInfo: { type: Object as () => TagInfo, required: true },
    value: { type: Boolean, required: true },
  },
});
